<template>
	<div class="serivce">
		<h1>竞拍具体流程</h1>
		<p> 一、注册认证：<br>
			1.首先竞买人/竞买机构需要登录“拍界”-委托拍卖平台（http://paijie.com/   ），点击首页左上角的“拍客登录”按钮进入注册页面，进行注册操作。<br>
			<img src="@/assets/images/liucheng1.jpg" class="liuchengtu"><br>
			2.注册成功后可直接进入实名认证操作；或者竞拍前，进入个人中心->实名认证页面，提交信息认证。提交信息类型和用户角色类型有关。<br>
			<img src="@/assets/images/liucheng2.jpg" class="liuchengtu"><br>
			3.企业实名认证：需要提交法人信息和营业执照等信息。提交成功后，“拍界”平台运营人员会及时审核用户的认证信息，在一个工作日以内审核完毕参加竞拍。<br>
			4.个人实名认证：需要提交个人证件等信息。网站面向个人提供两种实名认证的方式，一种是基于手机号码的第三方实名认证，一种是人工审核认证的方式。<br>
			二、拍前准备：<br>
			1.请在竞拍前，仔细阅读公告，了解拍品的详情.请确认您已知悉拍品的起拍时间、拍品描述、缴纳尾款的时间和方式、 其他竞买人注意事项。<br>
			2.了解拍品详情，联系拍卖企业看样，您可在拍品详情页查看《拍卖公告》、《拍卖须知》，如需实地查看拍卖标的，请注意查看联系方式、联系拍卖企业了解预展时间及拍卖注意事项。<br>
			<img src="@/assets/images/liucheng3.jpg" class="liuchengtu"><br>
			三、报名并交纳保证金<br>
			1.请在拍品详情页点击“报名”按钮进入报名并交纳保证金流程，报名前请先登录“拍界”账号，并确认您的“拍界”账号已经通过了实名认证。<br>
			2.报名时请确认保证金金额；并确认竞买人身份，填写准确的证件号。<br>
			<!-- 3.确认后进入网银进行支付，支付信息为：吉林省崇晟科贸有限公司 <br>开户行:{{$global.account_bank}} 账号：<b style="color: red;">{{$global.account_number}}</b><br> -->
			3.确认后按着平台指定的付款信息如数交纳保证金<br>
			四、出价竞拍：<br>
			1.确认出价金额，点击“加价”按钮进行竞拍。<br>
			2.出价规则：<br>
			a.默认按照加价幅度出价。<br>
			b.加价按钮设置为加价幅度的1倍、2倍、3倍、5倍<br>
			c.出价后不可连续出价;等有其他人出价既可以再次出价<br>
			3.延时规则：竞拍进入限时竞价时间，若有用户出价，结束时间系统将自动延时一个限时竞价时间，且不断循环。<br>
			<img src="@/assets/images/liucheng4.jpg" class="liuchengtu"><br>
			五、竞拍成功：<br>
			您可在个人中心-我的竞拍 查看所有已报名并交纳保证金的拍品，并看到对应拍品的状态，如果您已竞价成功，请联系拍卖企业进行线下尾款支付。<br>
			<img src="@/assets/images/liucheng5.jpg" class="liuchengtu"><br>
			六、资产交割：<br>
		买受人付款后应及时凭付款凭证及相关身份证明材料办理财产权证照转移协助执行通知书和办理拍卖拍品交付等相关事宜。拍卖财产所有权自拍卖成交裁定送达买受人时转移。买受人三个工作日内提取拍品，需办理过户手续的应及时办理过户手续。</p>
		<span @click="goBack">返回></span>
	</div>
</template>
<script>
export default {
	metaInfo: {
		title: "拍界——唤醒您的沉睡资产",
		meta: [{
			name: "keywords",
			content: "拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
		}, {
			name: "description",
			content: "拍界是一个专注拍卖的网络平台，拍卖无边界，拍卖更便捷。拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
		}]
	},
	created(){
		// 页面至顶部
		window.scrollTo(0,0);
	},
	methods:{
		goBack: function (){
			this.$router.go(-1)
		}
	}
}
</script>